/**
 * Created by mohit.chavda on 5/19/2017.
 */
export class Country {

  get label():string
  {
    //return this.countryCode;
    if(this.countryID <= 0)
      return this.countryCodeIso
    else
      return this.countryCodeIso + " - " + this.countryName;
  };
  get value():string
  {
    return this.countryCodeIso;
  };

  countryID:number;
  countryCodeIso:string;
  countryCodeUn:string;
  countryName:string;
}



// WEBPACK FOOTER //
// ./src/app/shared/Country.ts